import * as effects from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { projectsActions } from '../../actions';
import {
  FillProjectMatchingActionPayload,
  ProjectMatchingActionPayload,
} from '../../typedefs';

export function* projectMatching({
  payload,
}: PayloadAction<ProjectMatchingActionPayload>) {
  try {
    // yield effects.put(projectsActions.startFetching());
    const body: string = yield effects.call(JSON.stringify, payload);
    const response: Response = yield effects.apply(api, api.post, [
      { endpoint: 'projects/matching', body },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }

    const data: FillProjectMatchingActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(projectsActions.fillMatchingProject(data));
  } catch (e) {
    yield handleError(e);
  } finally {
    // yield effects.put(projectsActions.stopFetching());
  }
}
